"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Animation = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AnimationModule = _interopRequireDefault(require("./Animation.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Animation = function Animation(_ref) {
  var className = _ref.className,
      name = _ref.name,
      delay = _ref.delay,
      direction = _ref.direction,
      duration = _ref.duration,
      fillMode = _ref.fillMode,
      children = _ref.children,
      iterationCount = _ref.iterationCount,
      playState = _ref.playState,
      timingFunction = _ref.timingFunction,
      props = _objectWithoutProperties(_ref, ["className", "name", "delay", "direction", "duration", "fillMode", "children", "iterationCount", "playState", "timingFunction"]);

  var style = {
    animationDelay: delay,
    animationDirection: direction,
    animationDuration: duration,
    animationFillMode: fillMode,
    animationIterationCount: iterationCount,
    animationPlayState: playState,
    animationTimingFunction: timingFunction
  };
  var wrapperClass = _AnimationModule.default[name];
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", _extends({}, props, {
    className: wrapperClass,
    style: style
  }), children);
};

exports.Animation = Animation;
Animation.propTypes = {
  /** o nome da animação */
  name: _propTypes.default.string.isRequired,

  /** o delay da animação em milisegundos ou segundos (ms or s) */
  delay: _propTypes.default.string,

  /** a direção da animação */
  direction: _propTypes.default.oneOf(['normal', 'reverse', 'alternate', 'alternate-reverse']),

  /** a duração da animação em milisegundos ou segundos (ms or s) */
  duration: _propTypes.default.string,

  /** o estilo para o elemento quando a animação não está rodando */
  fillMode: _propTypes.default.oneOf(['none', 'forwards', 'backwards', 'both']),

  /** html nodes ou outros componentes */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),

  /** o número de vezes que a animação irá rodar */
  iterationCount: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.number, 'infinite']),

  /** o estado da animação */
  playState: _propTypes.default.oneOf(['paused', 'running']),

  /**  */
  timingFunction: _propTypes.default.oneOf(['linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out', _propTypes.default.string])
};
var _default = Animation;
exports.default = _default;